export default __webpack_public_path__ + "img/c744c5fa56efa5cf2dd490ab84402b8c.jpg";